import { useEffect } from 'react';

var useBrowserEffect = typeof window !== "undefined" ? useEffect : function () {};

export { useBrowserEffect };
//# sourceMappingURL=useBrowserEffect.js.map
